function HighlightText({ text, keyword }) {
  if (!keyword.trim()) {
    return text;
  }

  const escapedKeyword = keyword.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

  const regex = new RegExp(`(${escapedKeyword})`, 'gi');
  const parts = text.split(regex);

  return parts.map((part, index) =>
    part.toLowerCase() === keyword.toLowerCase() ? (
      <mark
        key={index}
        style={{
          backgroundColor: 'transparent',
          color: '#14A8E4',
        }}
      >
        {part}
      </mark>
    ) : (
      part
    )
  );
}

export default HighlightText;
